/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class AiAPI extends ApiClient {
  constructor() {
    super('loco/ai', { accountScoped: true });
  }

  settings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  testSettings() {
    return axios.post(`${this.url}/settings/test`);
  }

  usage() {
    return axios.get(`${this.url}/settings/usage`);
  }

  assistants() {
    return axios.get(`${this.url}/assistants`);
  }

  assistant(id) {
    return axios.get(`${this.url}/assistants/${id}`);
  }

  createAssistant(payload) {
    return axios.post(`${this.url}/assistants`, payload);
  }

  updateAssistant(id, payload) {
    return axios.patch(`${this.url}/assistants/${id}`, payload);
  }

  deleteAssistant(id) {
    return axios.delete(`${this.url}/assistants/${id}`);
  }

  playground(id, messages) {
    return axios.post(`${this.url}/assistants/${id}/playground`, { messages });
  }

  sources(assistantId) {
    return axios.get(`${this.url}/assistants/${assistantId}/sources`);
  }

  // A FormData payload uploads a file
  createSource(assistantId, payload) {
    return axios.post(`${this.url}/assistants/${assistantId}/sources`, payload);
  }

  updateSource(assistantId, id, payload) {
    return axios.patch(
      `${this.url}/assistants/${assistantId}/sources/${id}`,
      payload
    );
  }

  deleteSource(assistantId, id) {
    return axios.delete(`${this.url}/assistants/${assistantId}/sources/${id}`);
  }

  approveSource(assistantId, id) {
    return axios.post(
      `${this.url}/assistants/${assistantId}/sources/${id}/approve`
    );
  }

  // Reads the team's resolved conversations of the last `days` days for Q&A suggestions
  learn(assistantId, days) {
    return axios.post(`${this.url}/assistants/${assistantId}/learn`, { days });
  }

  // Learns the team's tone from its replies, in the background (settings.style_learned_at changes when done)
  learnStyle(assistantId) {
    return axios.post(`${this.url}/assistants/${assistantId}/learn_style`);
  }

  // Approves every suggestion in the background, merging the ones that ask the same thing
  approveSuggestions(assistantId) {
    return axios.post(
      `${this.url}/assistants/${assistantId}/approve_suggestions`
    );
  }

  syncSource(assistantId, id) {
    return axios.post(
      `${this.url}/assistants/${assistantId}/sources/${id}/sync`
    );
  }

  tools(assistantId) {
    return axios.get(`${this.url}/assistants/${assistantId}/tools`);
  }

  createTool(assistantId, payload) {
    return axios.post(`${this.url}/assistants/${assistantId}/tools`, payload);
  }

  updateTool(assistantId, id, payload) {
    return axios.patch(
      `${this.url}/assistants/${assistantId}/tools/${id}`,
      payload
    );
  }

  deleteTool(assistantId, id) {
    return axios.delete(`${this.url}/assistants/${assistantId}/tools/${id}`);
  }

  conversationState(conversationId) {
    return axios.get(`${this.url}/conversations/${conversationId}/state`);
  }

  handBack(conversationId) {
    return axios.post(`${this.url}/conversations/${conversationId}/resume`);
  }

  copilot(conversationId, question, history) {
    return axios.post(`${this.url}/conversations/${conversationId}/copilot`, {
      question,
      history,
    });
  }
}

export default new AiAPI();
